import { Translation } from 'react-i18next';
import './App.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import BenefitCalculator from './components/benefitCalculator';

function App() {
  return (
    <Translation>
    {
      t => (
        <BenefitCalculator t={t} />
      )
    }
    </Translation>
  );
}

export default App;
